import { PublicAccount } from '@unipile/types';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../../libs/axios';
import { QueryConfig } from '../../../types/react-query-utility';

async function getAccount({ accountId }: { appId: string; accountId: string }): Promise<PublicAccount> {
  const result = await axiosInstance.get<PublicAccount>(`/v2/accounts/${accountId}`);

  return result.data;
}

export const getAccountQueryOptions = (appId: string, accountId: string) => {
  return queryOptions({
    queryKey: ['accounts', appId, accountId],
    queryFn: () => getAccount({ appId, accountId }),
  });
};

type UseAccountOptions = {
  appId: string;
  accountId: string;
  queryConfig?: QueryConfig<typeof getAccountQueryOptions>;
};

export function useAccount({ queryConfig, appId, accountId }: UseAccountOptions) {
  return useQuery({
    ...getAccountQueryOptions(appId, accountId),
    ...queryConfig,
  });
}
